import { Menu } from 'antd';
import { PatientRoutePattern } from 'navigation/router/route-switch/route-switch-patient/utils/patient-route-helpers';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { MENU_CLINICIAN_PATIENT } from './menu-config';
import { useClinicianPatientMenuInfo } from './useClinicianPatientMenuInfo';
import { PatientRoutePrefix } from 'routes';

export function PatientSubMenu() {
  const menuItems = MENU_CLINICIAN_PATIENT;

  // We use `useRouteMatch` because the current context does not have access to the react-router context that resolves the path for routing
  const params = useRouteMatch<{ patientId: string }>(PatientRoutePattern);
  const location = useLocation();
  const clinicianPatientMenu = useClinicianPatientMenuInfo();

  const menuHighlightedRoute = clinicianPatientMenu.isMenuEnabled
    ? [
        PatientRoutePrefix,
        ':patientId',
        clinicianPatientMenu.match?.params.action
      ].join('/')
    : location.pathname;
  return (
    <Menu
      theme="light"
      mode="inline"
      openKeys={['patient']}
      selectedKeys={[menuHighlightedRoute]}
      items={[
        {
          key: 'patient',
          label: `Test-taker ${params?.params.patientId}`,
          type: 'submenu',
          children: menuItems
        }
      ]}
    />
  );
}
